// repositories/api/streamsRepository.js
import indexApi from './mixins/indexApi.js'
const resource = '/streams/'

export const streamsRepository = (axios) => ({
  async index(params) {
    return await indexApi(axios, resource, params)
  }
})
